import React from 'react';
import { distanceKmFromKitchen, formatKitchenDistance } from '../../pages/Cart/cartDistanceUtils';
import './DeliveryDistanceMeta.css';

/**
 * @param {{
 *   address?: { latitude?: number | null, longitude?: number | null } | null,
 *   distanceKm?: number | null,
 *   className?: string,
 * }} props
 */
const DeliveryDistanceMeta = ({ address = null, distanceKm = null, className = '' }) => {
  const km =
    Number.isFinite(distanceKm) ? distanceKm : address ? distanceKmFromKitchen(address) : null;
  const label = formatKitchenDistance(km);
  if (!label) return null;

  return (
    <span className={`delivery-distance-meta${className ? ` ${className}` : ''}`}>{label}</span>
  );
};

export default DeliveryDistanceMeta;
